module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"systemSettings":"System Settings","running":"attivo","stopped":"fermo","lastSyncDate":"Ultima sincronizzazione"}}')
  delete Component.options._Ctor
}
